import { render, staticRenderFns } from "./RankingList.vue?vue&type=template&id=327c33df&scoped=true"
import script from "./RankingList.vue?vue&type=script&lang=js"
export * from "./RankingList.vue?vue&type=script&lang=js"
import style0 from "./RankingList.vue?vue&type=style&index=0&id=327c33df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327c33df",
  null
  
)

export default component.exports